import QRCode from "qrcode.react";

import { LISDocument } from "pwapi";

import { CaseState } from "app/reducers/caseReducer";
import { truncatePatientName } from "util/patientUtils";

const DocumentBarcode = ({
  id,
  printCase,
}: {
  id: Number;
  printCase: CaseState;
}) => {
  const document = printCase?.documents.find((d) => d.id === id);
  const patientName = truncatePatientName(printCase?.patient);

  return document ? (
    <div className={`DecoratedBarcode DecoratedBarcode--document`}>
      <div className="Barcode BarcodeDocument">
        <p className="Barcode__label">
          {document?.category && (
            <strong>
              {document.category === LISDocument.category.REQUISITION_FORM
                ? document.category.split("-").at(0)
                : document.category.length <= 18
                ? document.category.replaceAll("-", " ")
                : document.category.replaceAll("-", "").substring(0, 18)}
            </strong>
          )}
        </p>
        <p className="Barcode__accession">
          {printCase?.accession}
          <br />
          {patientName}
        </p>
        <div className="Barcode__qr">
          <QRCode
            value={`document-${document.id}`}
            size={50}
            bgColor={"#ffffff"}
            fgColor={"var(--black)"}
            level={"Q"}
            includeMargin={false}
            renderAs={"svg"}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default DocumentBarcode;
